export { default } from './FeedbackCard';
export type { FeedbackCardCopy, FeedbackCardSubmission } from './FeedbackCard';
